import TodoList from "./TodoList";
import TaskWrapper from "../TaskWrapper";

export default function Todo({ list }) {
  return (
    <TaskWrapper title="TODO" total={list?.length} status="todo">
      <TodoList list={list} />
    </TaskWrapper>
  );
}
